import script from "./NodeProperties.vue?vue&type=script&setup=true&lang=js"
export * from "./NodeProperties.vue?vue&type=script&setup=true&lang=js"

import "./NodeProperties.vue?vue&type=style&index=0&id=7052992f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7052992f"]])

export default __exports__